import { cn } from "@/lib/utils";

type LogoProps = { className?: string; title?: string };

/**
 * Argentinian.Soccer shield mark — modern, sporty, instantly recognizable.
 * Pure SVG so it stays crisp at any DPR with zero network cost.
 */
export function LogoMark({ className, title = "Argentinian.Soccer" }: LogoProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      className={cn("h-9 w-9", className)}
    >
      <defs>
        <linearGradient id="as-shield" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#13306b" />
          <stop offset="100%" stopColor="#0a1a3d" />
        </linearGradient>
      </defs>
      {/* Shield */}
      <path
        d="M32 2 L58 10 V30 C58 46 47 56 32 62 C17 56 6 46 6 30 V10 Z"
        fill="url(#as-shield)"
      />
      {/* Sky stripes */}
      <path d="M6 22 H58 V28 H6 Z" fill="#7cc4ec" />
      <path d="M6 36 H58 V42 H6 Z" fill="#7cc4ec" />
      <rect x="6" y="28" width="52" height="8" fill="#ffffff" />
      {/* Three stars */}
      <g fill="#f4c64a">
        <Star cx={22} cy={12} r={2.2} />
        <Star cx={32} cy={11} r={2.4} />
        <Star cx={42} cy={12} r={2.2} />
      </g>
      {/* Monogram */}
      <text
        x="32"
        y="36"
        textAnchor="middle"
        fontFamily="'Bebas Neue', 'Barlow Condensed', sans-serif"
        fontSize="11"
        fill="#0a1a3d"
        letterSpacing="0.5"
      >
        AS
      </text>
    </svg>
  );
}

function Star({ cx, cy, r }: { cx: number; cy: number; r: number }) {
  const points = Array.from({ length: 10 }, (_, i) => {
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    const radius = i % 2 === 0 ? r : r * 0.45;
    return `${cx + Math.cos(angle) * radius},${cy + Math.sin(angle) * radius}`;
  }).join(" ");
  return <polygon points={points} />;
}

export function Logo({ className, mono = false }: { className?: string; mono?: boolean }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <LogoMark className="h-9 w-9" />
      <span
        className={cn(
          "font-display text-xl font-bold tracking-tight",
          mono ? "text-primary-foreground" : "text-navy",
        )}
      >
        Argentinian
        <span className={mono ? "text-sky" : "text-primary"}>.Soccer</span>
      </span>
    </div>
  );
}
